import { Alert } from '@bb/elements-web';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { featureEnabled } from 'utils';
import AppointmentBookingInternalContext from '../AppointmentBookingInternalContext';

const PreBookingInfoAlert: React.FC = () => {
  const { listing, partialAppointmentConfig } = useContext(
    AppointmentBookingInternalContext,
  );
  if (!featureEnabled('preBookingNotificationFeature')) return null;
  if (!listing!.org.features.includes('PRE_BOOKING')) return null;
  if (!partialAppointmentConfig!.preBookingInformation) return null;

  return (
    <StyledAlert
      data-cy="preBookingInfo-alert"
      type="info"
      message={partialAppointmentConfig!.preBookingInformation}
      showIcon
      closable
    />
  );
};

const StyledAlert = styled(Alert)`
  && {
    padding: 6px 10px;
    margin-bottom: 8px;
  }
`;

export default PreBookingInfoAlert;
